import TableList from "@components/templates/tablelist";
import { HttpAccessGroupList, HttpDelAccessGroup } from "@/service/ucadm";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            // formData: {},
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            // formData: {
            //     module: 'DataReport'
            // },
            Plugins: { show: true }
        };
    },
    components: {
        compUpdate
    },
    methods: {
        ajaxRequest: HttpAccessGroupList,
        interceptRequest: (request) => {
            return {
                ...request,
                module: 'DataReport'
            }
        },
        handleOperates(params = "", type, batch) {
            if (batch) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "add":
                    this.operate = {
                        show: true,
                        params: { id: params, type: "add" },
                        title: "添加分组",
                        component: "compUpdate",
                        width: 1000,
                        showFooter: false
                    };
                    break;
                case "edit":
                    this.operate = {
                        show: true,
                        params: { id: params, type: "edit" },
                        title: "编辑分组",
                        component: "compUpdate",
                        width: 1000,
                        showFooter: false
                    };
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "删除该分组",
                        ajaxRequest: HttpDelAccessGroup
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: "编辑",
                    show: true,
                    params: id,
                    operate: "edit"
                },
                {
                    label: "删除",
                    show: true,
                    params: id,
                    operate: "del"
                }
            ];
        }
    },
    computed: {
        ToolsData() {
            return [
                {
                    name: "添加分组",
                    operate: "add",
                    theme: "primary"
                }
            ];
        },
        SearchsData() {
            return [
                {
                    label: "名称",
                    tag: "vInput",
                    key: "CN_displayName",
                    show: true
                }
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: "分组名称",
                    key: "displayName",
                    sortable: true
                },
                {
                    title: "分组描述",
                    key: "description"
                },
                {
                    title: "更新时间",
                    key: "updatedAt"
                }
            ];
        }
    }
};
